<template>
    <v-container fill-height v-if="survey && plant">
        <v-subheader>{{$t('key.location')}}</v-subheader>

        <v-row v-if="isAuthenticated">
            <v-col>
                <MapViewer :shape="survey.shape" :plantId="plant.uuid"></MapViewer>
            </v-col>
        </v-row>

        <v-subheader>{{$t('key.propagation')}}</v-subheader>

        <v-row v-if="survey.numberOfPlants && survey.numberOfPlants > 0">
            <v-col cols="2">
                <v-icon>mdi-sprout</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.numberOfPlants}}</label>
                <span> {{$t('key.piece')}}</span>
            </v-col>
        </v-row>

        <v-row v-if="survey.areaOfPlants">
            <v-col cols="2">
                <v-icon>mdi-set-square</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.areaOfPlants}} <i>{{$t('key.areaOfPlantsUnit')}}</i></label>
            </v-col>
        </v-row>

        <v-subheader>{{$t('key.properties')}}</v-subheader>

        <v-row>
            <v-col cols="2">
                <v-icon>mdi-calendar-range</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.date}}</label>
            </v-col>
        </v-row>

        <v-subheader v-if="isAuthenticated">{{$t('key.action')}}</v-subheader>

        <v-row v-if="isAuthenticated">
            <v-col cols="2">
                <v-icon>mdi-clock-outline</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.timeStart}} - {{survey.timeEnd}}</label>
            </v-col>
        </v-row>

        <v-row v-if="isAuthenticated">
            <v-col cols="2">
                <v-icon>mdi-account-tie</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.customer}}</label>
            </v-col>
        </v-row>

        <v-row v-if="isAuthenticated">
            <v-col cols="2">
                <v-icon>mdi-shovel</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.action | actionText | capitalize}}</label>
            </v-col>
        </v-row>

        <v-row v-if="isAuthenticated">
            <v-col cols="2">
                <v-icon>mdi-numeric</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.amountValue}} {{survey.amountUnit | quantityText}}</label>
            </v-col>
        </v-row>

        <v-row v-if="isAuthenticated && survey.note">
            <v-col cols="2">
                <v-icon>mdi-comment</v-icon>
            </v-col>
            <v-col cols="10">
                <label>{{survey.note}}</label>
            </v-col>
        </v-row>

        <!--
        <v-carousel>
            <v-carousel-item v-for="(photo, idx) in survey.photos" :key="idx" :src="photo"
                             reverse-transition="fade-transition" transition="fade-transition"></v-carousel-item>
        </v-carousel>
        -->
    </v-container>
</template>

<script>
    import {Actions, Quantities, VegetationStages} from '../../_helpers';
    import MapViewer from '../map/MapViewer';

    export default {
        name: 'SurveyContext',
        props: ['survey', 'plant'],
        components: {
            MapViewer
        },
        computed: {
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            }
        },
        filters: {
            actionText(enumValue) {
                let action = Actions.itemByValue(enumValue)
                return action ? action.text : "-"
            },
            quantityText(enumValue) {
                let quantity = Quantities.itemByValue(enumValue)
                return quantity ? quantity.text : "-"
            },
            vegetationStageText(enumValue) {
                let vegetationStage = VegetationStages.itemByValue(enumValue)
                return vegetationStage ? vegetationStage.text : "-"
            },
            capitalize(value) {
                if (!value)
                    return ''

                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        }
    }
</script>
